export default __webpack_public_path__ + "static/media/Humana.291bfbef.jpg";